export default {
    fsmRoute_routesTracker_modalfilters_title: "Filtrar por",  
    fsmRoute_routesTracker_modalfilters_clearFilters: 'Limpiar filtros',
	fsmRoute_routesTracker_modalfilters_clearAll: 'Limpiar todo', 
    fsmRoute_routesTracker_modalfilters_close: 'Cerrar',
    fsmRoute_routesTracker_modalfilters_no_driver: 'Sin Conductor Asignado',
    fsmRoute_routesTracker_modalfilters_status: 'Estado',
};